<template>
  <div class="col-md-6 col-lg-4 mb-4">
    <NuxtLink :to="to" style="text-decoration: none; display: block;">
      <div 
        class="card h-100" 
        style="border: none; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08); transition: all 0.3s; overflow: hidden; cursor: pointer;" 
        @mouseover="onMouseOver" 
        @mouseout="onMouseOut"
      >
        <div :style="headerStyle">
          <div style="position: absolute; top: 0; right: 0; width: 60px; height: 60px; background: rgba(255,255,255,0.1); border-radius: 50%; transform: translate(20px, -20px);" />
          <h5 style="font-weight: 600; margin-bottom: 8px; font-size: 1.1rem; position: relative; z-index: 2;">{{ title }}</h5>
          <p style="opacity: 0.9; margin: 0; font-size: 0.9rem; position: relative; z-index: 2;">{{ subtitle }}</p>
        </div>
        <div class="card-body" style="padding: 20px; background: white;">
          <p style="color: #666; line-height: 1.5; margin-bottom: 16px; font-size: 0.9rem;">{{ description }}</p>
          <span class="btn btn-sm" :style="buttonStyle">{{ props.buttonText }} →</span>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  to: {
    type: String,
    required: true
  },
  gradientStart: {
    type: String,
    default: '#3b82f6'
  },
  gradientEnd: {
    type: String,
    default: '#1d4ed8'
  },
  buttonText: {
    type: String,
    required: true
  }
})

// Access props directly in template

const headerStyle = computed(() => {
  return `background: linear-gradient(135deg, ${props.gradientStart}, ${props.gradientEnd}); padding: 20px; color: white; position: relative;`
})

const buttonStyle = computed(() => {
  return `background: linear-gradient(135deg, ${props.gradientStart}, ${props.gradientEnd}); color: white; border: none; padding: 8px 16px; border-radius: 6px; font-weight: 500; text-decoration: none; display: inline-block; transition: all 0.3s; font-size: 0.85rem;`
})

const onMouseOver = (event) => {
  if (event.currentTarget) {
    event.currentTarget.style.transform = 'translateY(-4px)';
    event.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
  }
};

const onMouseOut = (event) => {
  if (event.currentTarget) {
    event.currentTarget.style.transform = 'translateY(0)';
    event.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
  }
};
</script>
